import React from 'react';
import './errorBoundary.scss';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
    
    // Log error to console in development
    if (process.env.NODE_ENV === 'development') {
      console.error('Error caught by boundary:', error, errorInfo);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary">
          <div className="error-content">
            <div className="error-icon">🍞</div>
            <h1>¡Ups! Algo salió mal</h1>
            <p>
              Parece que hubo un problema técnico. Por favor, intenta recargar la página 
              o contáctanos si el problema persiste.
            </p>
            <div className="error-actions">
              <button 
                onClick={() => window.location.reload()} 
                className="reload-btn"
              >
                Recargar Página
              </button>
              <a 
                href="/contactenos" 
                className="contact-btn"
              >
                Contactar Soporte
              </a>
            </div>
            {process.env.NODE_ENV === 'development' && this.state.error && (
              <details className="error-details">
                <summary>Detalles del Error (Solo Desarrollo)</summary>
                <pre>{this.state.error.toString()}</pre>
                <pre>{this.state.errorInfo.componentStack}</pre>
              </details>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary; 